import React from 'react';
import { getNumberFrequency, getHistory } from '../utils/localStorage';
import './Statistics.css';

const Statistics = () => {
  const [frequency, setFrequency] = React.useState({});
  const [mostCommon, setMostCommon] = React.useState([]);

  React.useEffect(() => {
    updateStatistics();
  }, []);

  const updateStatistics = () => {
    const freq = getNumberFrequency();
    setFrequency(freq);
    
    // Get top 6 most common numbers
    const sorted = Object.entries(freq)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 6)
      .map(([num]) => parseInt(num));
    
    setMostCommon(sorted);
  };

  React.useEffect(() => {
    // Update statistics when history changes
    const interval = setInterval(() => {
      updateStatistics();
    }, 2000);
    
    return () => clearInterval(interval);
  }, []);

  const history = getHistory();
  const totalGenerations = history.length;

  if (totalGenerations === 0) {
    return (
      <div className="card bg-light bg-opacity-10 border-0">
        <div className="card-body text-center">
          <h5 className="card-title text-white">Statistiken</h5>
          <p className="text-white-50 mb-0">Generiere Zahlen, um Statistiken zu sehen!</p>
        </div>
      </div>
    );
  }

  const maxFrequency = Math.max(...Object.values(frequency), 1);

  return (
    <div className="card bg-light bg-opacity-10 border-0">
      <div className="card-body">
        <h5 className="card-title text-white mb-4">Statistiken</h5>
        <div className="mb-4">
          <p className="text-white mb-0">Gesamt generiert: <strong>{totalGenerations}</strong> Mal</p>
        </div>
        
        {mostCommon.length > 0 && (
          <div className="mb-4">
            <h6 className="text-white mb-3">Häufigste Zahlen:</h6>
            <div className="d-flex gap-2 flex-wrap justify-content-center">
              {mostCommon.map((num) => (
                <div key={num} className="stat-number-ball">
                  {num}
                  <span className="stat-frequency">({frequency[num] || 0}x)</span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div>
          <h6 className="text-white mb-3">Häufigkeit aller Zahlen:</h6>
          <div className="frequency-grid">
            {Array.from({ length: 49 }, (_, i) => i + 1).map(num => {
              const count = frequency[num] || 0;
              const percentage = maxFrequency > 0 ? (count / maxFrequency) * 100 : 0;
              return (
                <div key={num} className="frequency-item">
                  <div className="frequency-bar-container">
                    <div
                      className="frequency-bar"
                      style={{ height: `${percentage}%` }}
                      title={`${num}: ${count}x`}
                    ></div>
                  </div>
                  <span className="frequency-number">{num}</span>
                  <span className="frequency-count">{count}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Statistics;
